import React from 'react'

import { useFetchRecommendationsPositions } from '@/core/hooks/useFetchRecommendationsPositions'

import styles from './styles'

const CandidatesNavItemLabel = () => {
  const { recommendationListCount } = useFetchRecommendationsPositions()
  const isIndicatorVisible = recommendationListCount > 0

  return (
    <>
      Candidates
      {isIndicatorVisible && (
        <span className={styles.indicator}>
          <span className={styles.accessiblyHidden}>You have recommendations to review</span>
        </span>
      )}
    </>
  )
}

export default CandidatesNavItemLabel
